import { formatDate, formatDateTime } from '../../utils/api'

/**
 * The time lines above a customer email in the ticket thread: when they
 * sent it, and when the Gmail sync brought it into Prism.
 *
 * Works for the ticket itself (received_at / created_at) and for an inbound
 * reply (sent_at / synced_at). Rows synced before 2026-10-19 have no Gmail
 * time. An old inbound reply's one time is its sync time. A ticket without
 * received_at may be one staff started from a deal or order, whose first
 * email is ours, so it only says when the row was added.
 */
const plainDateTime = v => formatDateTime(v).replace(',', '')

export function emailTimeLines(row, fmt = plainDateTime) {
  const isReply = row.direction !== undefined
  const sent = isReply ? (row.synced_at ? row.sent_at : null) : row.received_at
  const synced = isReply ? (row.synced_at || row.sent_at) : row.created_at
  const syncedLabel = isReply || sent ? 'Synced to Prism' : 'Added to Prism'
  return [
    sent && `Email sent: ${fmt(sent)}`,
    synced && `${syncedLabel}: ${fmt(synced)}`,
  ].filter(Boolean)
}

/**
 * The date on a ticket list row, on desktop and on the phone. It is the Gmail
 * send time when we have it, with both times on hover. A row synced before
 * 2026-10-19 has none, so it keeps the sync date and is flagged so the list
 * does not pass it off as a send date.
 */
export function ticketRowDate(ticket, fmtDate = formatDate, fmtDateTime = plainDateTime) {
  if (ticket.received_at) {
    return {
      text: fmtDate(ticket.received_at),
      title: `Email sent ${fmtDateTime(ticket.received_at)} · synced ${fmtDateTime(ticket.created_at)}`,
      isSyncTime: false,
    }
  }
  return {
    text: fmtDate(ticket.created_at),
    title: `Synced to Prism ${fmtDateTime(ticket.created_at)}. Sent time not recorded.`,
    isSyncTime: true,
  }
}
